module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_btn02-09c08a52c3fbc341d74022bcd202a507.png";